var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_vm._v("\n  "+_vm._s(_vm.num)+"}\n  "),_c('ul',_vm._l((_vm.datauser),function(user,index){return _c('li',{key:index},[_vm._v("\n    "+_vm._s(user)+"\n  ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }